import { useMemo, useState } from 'react';
import type { OUItem } from '@/api/types';
import { buildOuTree, collectIdsWithChildren, type OuNode } from './ouTree';

export interface UseOuExpansionResult {
  tree: OuNode[];
  isCollapsed: (nodeId: string) => boolean;
  toggle: (nodeId: string) => void;
}

/** Árbol construido desde `items` + estado de expand/collapse; todo nodo con hijos empieza colapsado. */
export function useOuExpansion(items: OUItem[]): UseOuExpansionResult {
  const tree = useMemo(() => buildOuTree(items), [items]);
  const defaultCollapsed = useMemo(() => collectIdsWithChildren(tree), [tree]);
  const [manualState, setManualState] = useState<Set<string> | null>(null);
  const collapsedIds = manualState ?? defaultCollapsed;

  function isCollapsed(nodeId: string): boolean {
    return collapsedIds.has(nodeId);
  }

  function toggle(nodeId: string): void {
    setManualState(previousState => {
      const nextState = new Set(previousState ?? defaultCollapsed);
      if (nextState.has(nodeId)) nextState.delete(nodeId);
      else nextState.add(nodeId);
      return nextState;
    });
  }

  return { tree, isCollapsed, toggle };
}
